import {
  getMessageFromNetworkError,
  useMoveAssetsToFolder,
} from "@zapier/client";
import { getFolderUrl, useNotification } from "@zapier/utils";
import { Link, Text } from "@zapier/design-system";
import { useTranslations } from "@zapier/i18n";

interface Input {
  assetTitle: string | undefined | null;
  assetParentId?: string | null;
  onSettled?: () => void;
  isBulk?: boolean;
}

export function useMoveAssetActions({
  assetTitle,
  assetParentId,
  onSettled,
  isBulk = false,
}: Input) {
  const t = useTranslations("move-asset-actions");
  const { createNotification } = useNotification();
  const { moveAssetsToFolder } = useMoveAssetsToFolder({
    folderId: assetParentId,
  });

  // Move assets between folders
  const moveAssetsToFolderWithToasts = ({
    assetIds,
    selectedFolderId,
    selectedFolderName,
  }) => {
    moveAssetsToFolder(
      {
        destinationFolderId: selectedFolderId,
        assetIds,
      },
      {
        onSuccess: () => {
          createNotification({
            message: (
              <Text>
                {t.rich("notifications.move-success", {
                  assetTitle: assetTitle || "",
                  isBulk: String(isBulk),
                  selectedFolderName,
                  folderLink: (chunks) => (
                    <Link href={getFolderUrl(selectedFolderId)}>{chunks}</Link>
                  ),
                })}
              </Text>
            ),
            type: "success",
          });
        },
        onError: (error: any) => {
          createNotification({
            title: t("errors.unable-to-move", { assetTitle: assetTitle || "" }),
            message: getMessageFromNetworkError(error),
            type: "error",
          });
        },
        onSettled: () => {
          onSettled?.();
        },
      },
    );
  };

  return {
    moveAssetsToFolderWithToasts,
  };
}
